import { CampaignType, CampaignState } from 'cio/models/campaign';
import { SendStateType } from 'cio/models/newsletter';

export interface Usage {
  id: string;
  name: string;
  type: CampaignType | 'newsletter';
  updated: number;
  state: CampaignState | SendStateType;
}

export default interface SubscriptionTopicUsage {
  campaigns: Usage[];
  broadcasts: Usage[];
  newsletters: Usage[];
}

export function isUsedInRunningCampaign(campaign: Usage) {
  return campaign.state === CampaignState.Running;
}

export function isUsedInRunningBroadcast(broadcast: Usage) {
  return broadcast.state === 'running';
}

export function isUsedInScheduledOrRunningNewsletter(newsletter: Usage) {
  return newsletter.state === 'scheduled';
}
